/*
* 操作日志管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
} from 'antd';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
} from '../../incs/FunHelper.js';

const Option = Select.Option;

const Lists = (props) => {
    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '操作者', dataIndex: 'operation', key: 'operation', fixed: 'left', },
        { title: '操作对象', dataIndex: 'instance', key: 'instance', },
        { title: '模块', dataIndex: 'module', key: 'module', },
        { title: '动作', dataIndex: 'action', key: 'action', },
        {
            title: '描述', key: 'description',
            render: (record) => record.description ? record.description : '-'
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', sorter: (a, b) => Date.parse(a.create_time) - Date.parse(b.create_time), width: CNF.tableCreateTimeColumnWidth + 60 },
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                scroll={{ x: props.x }}
                showSorterTooltip={{ target: 'sorter-icon' }}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            operation: '',
            instance: '',
            module: '',
            action: ''
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeOperation = (e) => { this.setState({ operation: e.target.value }); this.search(); }
    changeInstance = (e) => { this.setState({ instance: e.target.value }); this.search(); }
    changModule = (value) => { this.setState({ module: value ? value : '' }); this.search(); }
    changAction = (value) => { this.setState({ action: value ? value : '' }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    /**
     * 获取操作日志列表
     */
    getLists() {
        const _this = this;
        const params = {
            'operation': this.state.operation,
            'instance': this.state.instance,
            'module': this.state.module,
            'action': this.state.action,
            'page_size': isGTscreenWidth ? CNF.pageSize : CNF.pageSize - 2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}log/operations${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeOperation}
                            placeholder='操作者'
                            value={this.state.operation}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 4 : 5} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeInstance}
                            placeholder='操作对象'
                            value={this.state.instance}
                        />
                    </Col>
                    <Col span={3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='模块'
                            style={{ width: '100%' }}
                            onChange={this.changModule}
                        >
                            {
                                Object.keys(CNF.navItems).map((key) => {
                                    if (CNF.navItems[key].submenu) {
                                        return CNF.navItems[key].submenu.map((item) => {
                                            if (item.isLogModule && this.props.btnLists.indexOf(item.ptn) >= 0) {
                                                return <Option value={item.name}>{item.name}</Option>
                                            } else {
                                                return ''
                                            }
                                        })
                                    } else if (CNF.navItems[key].isLogModule && this.props.btnLists.indexOf(CNF.navItems[key].ptn) >= 0) {
                                        return <Option value={CNF.navItems[key].name}>{CNF.navItems[key].name}</Option>
                                    } else {
                                        return ''
                                    }
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='动作'
                            style={{ width: '100%' }}
                            onChange={this.changAction}
                        >
                            {
                                Object.keys(CNF.actionName).map((key) => {
                                    if (this.props.btnLists?.indexOf(key.toLowerCase()) > -1) {
                                        return <Option key={key} value={CNF.actionName[key]}>{CNF.actionName[key]}</Option>
                                    } else {
                                        return null
                                    }
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT